import Chart from "chart.js/auto"
export default Chart
